import { ProductIds } from '../../../../constants';

/** Whether the product's carrier issues its policy numbers: only HDI's does. */
export const carrierIssuesPolicyNumbers = (product?: { id?: string } | null) => product?.id === ProductIds.HDI;

/** Whether the quote's carrier issues its policy number and the quote holds none yet, so it can be neither released nor prebound. */
export const needsCarrierPolicyNumber = (quote: { product?: { id?: string } | null; policyNumber?: string | null }) =>
  carrierIssuesPolicyNumbers(quote.product) && !(quote.policyNumber ?? '').trim();
